import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { IdNameSymbolResponse } from 'services/tenantManagementService';
import { COUNTRIES_SET, COUNTRIES_FETCHING } from './action';

export const countryReducer = (state = new PersistItemsReducer<IdNameSymbolResponse>(), action: PersistItemsActionType<IdNameSymbolResponse> | FetchingActionType): PersistItemsReducer<IdNameSymbolResponse> => {
	switch (action.type) {
		case COUNTRIES_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case COUNTRIES_SET:
			const { items } = action as PersistItemsActionType<IdNameSymbolResponse>;

			const itemsMap: { [id: number]: IdNameSymbolResponse } = items.reduce(
                (map: { [id: number]: IdNameSymbolResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
